module.exports = __webpack_public_path__ + "static/media/BharatAudioLive.2ebcec6a.png";